import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class DistributorReferralMaintenanceService {

    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;

    getDistributors(zip: any, miles: any) {
        return this.http.get<any>(this.baseurl + 'distributor/distributors?zip=' + zip + '&miles=' + miles);
    }

    getDistributorStates() {
        return this.http.get<any>(this.baseurl + 'distributor/getdistributorstates');
    }

    pickMe(data: any) {
        return this.http.post<any[]>(this.baseurl + "distributor/pickme", data);
    }

    addDistributor(distributor: any) {
        return this.http.post<any[]>(this.baseurl + "distributor/adddistributor", distributor);
    }

    updateDistributor(distributor: any) {
        return this.http.post<any[]>(this.baseurl + "distributor/updatedistributor", distributor);
    }
}